export default __webpack_public_path__ + "static/NJSOMA 2024 1(2) 57 to 59-3ea73155ff577a7d40f9e5cc288d4159.pdf";